import { system } from 'styled-system'

export const itemGap = system({
  gapBottom: {
    property: 'marginBottom',
    scale: 'space',
  },
  gapLeft: {
    property: 'marginLeft',
    scale: 'space',
  },
  gapRight: {
    property: 'marginRight',
    scale: 'space',
  },
  gapTop: {
    property: 'marginTop',
    scale: 'space',
  },
})
